<template>
  <div class="row">
    <div class="col-lg-1"></div>
    <div class="col-lg-10">
      <textarea
        v-model="text"
        class="form-control"
        cols="30"
        rows="10"
        placeholder="Digite sua resposta aqui"
      />
      <button @click="saveAnswer" class="btn btn-primary full mt-2">
        Enviar resposta
      </button>
    </div>
    <div class="col-lg-1"></div>
  </div>
</template>

<script>
export default {
  props: ["question", "index", "currentTime", "is_evaluation", "answers"],
  data: () => ({
    text: "",
  }),
  mounted() {
    if (this.answers?.length > 0) {
      const answer = this.answers.find(
        (answer) => answer.question_id == this.question.id
      );
      if (answer) {
        this.text = answer.choices.text;
      }
    }
  },
  methods: {
    saveAnswer() {
      if (this.text.length < 1 && !this.question.choices.canBeEmpty) {
        this.$toast.error("Por favor, responda a pergunta corretamente");
        return;
      }

      let answers = {
        question_id: this.question.id,
        time_taken: this.currentTime,
        evaluation_id: this.question.evaluation_id,
        choices: {
          text: this.text,
        },
      };

      axios.post("/candidates/answers", { answers }).then((response) => {
        if (response.status) {
          if (this.is_evaluation) {
            this.$emit("nextQuestion", this.text, response.data.answer);
            this.$emit("saveAnswers", answers);
            return;
          }
          eventBus.$emit("nextQuestion", this.index);
          this.$emit("saveAnswers", answers);
        }
      });
    },
  },
  watch: {
    question() {
      this.text = "";
    }
  }
};
</script>